<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="selectRecipientIsOpen"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: redeliverEmail,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Redeliver'
    }"
  >
    <template slot="dialog_data">
      <v-card-text class="px-12 file-data-container">
        <v-row class="file-head">
          <Checkbox
            theme="dark"
            id="srd"
            class="white--text"
            v-model="checkboxAll"
            title="Recipient"
            @click="selectAll"
          ></Checkbox>
        </v-row>
        <div class="file-list">
          <v-row
            v-for="(item, index) in attachList"
            :key="index"
            class="file-data"
            :class="{ 'grey lighten-5': index % 2 !== 0 }"
          >
            <Checkbox
              :title="item"
              :id="'srd-checkbox' + index"
              theme="light"
              v-model="attachmentId"
              :value="item"
              @click="select"
            ></Checkbox>
          </v-row>
        </div>
      </v-card-text>
    </template>
  </x-dialog>
</template>

<script>
import EventBus from '@/EventBus';
import Checkbox from '@/components/Common/Checkbox';
export default {
  components: {
    Checkbox
  },
  data() {
    return {
      selectRecipientIsOpen: false,
      dialogTitle: 'Select Recipients',
      attachList: [],
      checkboxAll: false,
      emptyArray: false,
      attachmentId: [],
      archiveId: ''
    };
  },
  mounted() {
    EventBus.$on('SELECT_RECEIPIENT', val => {
      this.selectRecipientIsOpen = true;
      this.attachList = val;
    });
  },
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  methods: {
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.selectRecipientIsOpen) {
        this.closeDialog();
      }
    },
    redeliverEmail() {
      if (this.attachmentId.length) {
        EventBus.$emit('REDELIVER_EMAIL', this.attachmentId);
        this.closeDialog();
      }else {
        this.snackbar('error', 'Select the recipient');
      }
    },
    closeDialog() {
      this.selectRecipientIsOpen = false;
      this.attachmentId = [];
      this.checkboxAll = false;
    },
    selectAll() {
      this.attachmentId = [];
      if (this.checkboxAll) {
        this.attachList.forEach(ele => {
          this.attachmentId.push(ele.toString());
        });
      } else {
        this.select();
      }
    },
    select() {
      if (this.attachmentId.length === this.attachList.length) {
        this.checkboxAll = true;
      } else {
        this.checkboxAll = false;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('SELECT_RECEIPIENT');
  }
};
</script>

<style>
.white--text .label {
  color: #fff !important;
}
.file-head {
  background-color: #1b2342;
  color: #fff;
  padding: 8px 13px;
  font-size: 17px;
  font-weight: 600;
}
.file-head input[type='checkbox'],
.file-head label {
  color: #fff !important;
}
.file-data {
  padding: 8px 13px;
  font-size: 17px;
  font-weight: 600;
}
</style>
